function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import "./unstyledTextButton.css";

/*
    Returns a basic Button

    props
        (string)    classPrepend  The base name of all classes, to make styling specific to an implementation
        (function)  onClick       Event handler function to be called when the button is clicked.
        (string)    type          Optional.  The type of the button. Default value is (eg... submit)
        (boolean)   disabled      Optional. Determines whether the button is disabled. Default value is false.
        (any)       children      Optional. The content to be displayed in the button.
*/

const UnstyledTextButton = ({
  classPrepend = "unstyled",
  className = "",
  onClick,
  type = "button",
  disabled = false,
  children,
  ...rest
}) => {
  const handleOnClick = e => {
    if (disabled) return;
    if (onClick) onClick(e);
  };
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type,
    className: `${classPrepend}-text-button text-button ${className}`,
    onClick: handleOnClick,
    disabled: disabled
  }, rest), children);
};
export { UnstyledTextButton };